module.exports = __webpack_public_path__ + "img/art.6a8111ad.svg";